<template>
  <section>
    <div class="modal-card">

      <header class="modal-card-head">
        <div class="title is-bold">Edit Note</div>
      </header>

      <section class="modal-card-body">

        <b-field
          horizontal
          label="Note"
        >
          <b-input
            @focus="$event.target.select()"
            name="theNote"
            v-model="c.theNote"
            type="text"
            placeholder="The note..."
            expanded
          ></b-input>
        </b-field>

        <b-field
          horizontal
          label="Stage"
        >
          <b-select
            placeholder="Select stage"
            v-model="c.stage"
            expanded
          >
            <option
              v-for="stage in getStages()"
              :value="stage"
              :key="stage"
            >
              {{ stage }}
            </option>
          </b-select>
        </b-field>

        <b-field
          horizontal
          label="Date"
        >
          <b-datepicker
            inline
            v-model="c.createdUtc"
            icon="calendar-today"
            editable
            expanded
          ></b-datepicker>
        </b-field>

        <b-message
          type="is-danger"
          has-icon
          v-if="this.errorMessage"
        >
          {{ this.errorMessage }}
        </b-message>

      </section>

      <footer class="modal-card-foot">
        <button
          class="button"
          @click="() => { cancel(); $parent.close() }"
        >Cancel</button>
        <button
          :disabled="c.theNote.length == 0"
          class="button is-primary"
          @click="() => { saveEdit(); $parent.close() }"
        >Save changes</button>
      </footer>

    </div>
  </section>
</template>

<script>
import Helpers from "@/services/Helpers.js";

export default {
  components: {
    Helpers
  },

  data() {
    return {
      errorMessage: "",
      c: {
        id: "",
        propertyId: "",
        createdUtc: new Date(),
        stage: "",
        theNote: ""
      },
      originalNote: ""
    };
  },

  computed: {
    connection() {
      return this.$store.state.connectionEdit.connection;
    },

    originalConnection() {
      return this.$store.state.connectionEdit.originalConnection;
    }
  },

  mounted() {
    console.log("mounted()", this.$store.state.noteEdit);
    this.c.id = this.$store.state.noteEdit.note.id;
    this.c.propertyId = this.$store.state.noteEdit.note.propertyId;
    console.log(
      "this.$store.state.noteEdit.note.createdUtc",
      this.$store.state.noteEdit.note.createdUtc
    );
    this.c.createdUtc = new Date(this.$store.state.noteEdit.note.createdUtc);
    this.c.stage = this.$store.state.noteEdit.note.stage;
    this.c.theNote = this.$store.state.noteEdit.note.theNote;
    console.log("mounted().c", this.c);
    console.log("mounted().c.createdUtc", this.c.createdUtc);

    console.log(
      "mounted() theNote = ",
      this.$store.state.noteEdit.note.theNote
    );
    this.originalNote = this.$store.state.noteEdit.note.theNote;
  },

  methods: {
    getStages() {
      return Helpers.getStages();
    },

    cancel() {
      console.log("cancel()");
    },

    async saveEdit() {
      console.log("saveEdit()", this.c);
      var propertyId = this.c.propertyId;
      var note = this.c;
      note.createdUtc = note.createdUtc.toISOString();
      console.log("note.createdUtc=", note.createdUtc);
      await this.$store.dispatch("updatePropertyNote", { propertyId, note });
      var foundIndex = this.$store.state.notes.findIndex(
        x => x.id == this.c.id
      );
      this.$store.state.notes[foundIndex].theNote = this.c.theNote;
      this.$store.state.notes[foundIndex].createdUtc = this.c.createdUtc;
      this.$store.state.notes[foundIndex].stage = this.c.stage;
    }
  }
};
</script>

<style>
</style>
